import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { capabilityService, validateCapabilities } from '../services/capabilityService';
const OFF = { inlineAnswers: false, extendedChat: false, contentRevision: null };
const Context = createContext({ ...OFF, loading: true, refresh: () => {}, disable: () => {} });
export function CapabilitiesProvider({ children }) {
  const [state, setState] = useState({ ...OFF, loading: true });
  const request = useRef();
  const refresh = useCallback(async () => {
    request.current?.abort();
    const controller = new AbortController();
    request.current = controller;
    // Revalidate without destroying an already validated feature scope. Initial
    // discovery and explicit disable still start off; failed/invalid results close it.
    setState((previous) => ({ ...previous, loading: true }));
    try {
      const data = await capabilityService.get(controller.signal);
      if (!controller.signal.aborted) setState({ ...validateCapabilities(data), loading: false });
    } catch (_) {
      if (!controller.signal.aborted) setState({ ...OFF, loading: false });
    }
  }, []);
  const disable = useCallback(() => { setState({ ...OFF, loading: false }); refresh(); }, [refresh]);
  useEffect(() => {
    refresh(); window.addEventListener('focus', refresh);
    return () => { request.current?.abort(); window.removeEventListener('focus', refresh); };
  }, [refresh]);
  return <Context.Provider value={{ ...state, refresh, disable }}>{children}</Context.Provider>;
}
export const useCapabilities = () => useContext(Context);
